import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import eventBus from './eventBus';

const NavigationEventListener = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleNavigateBack = () => {
      navigate(-1);
    };

    eventBus.on('navigateBack', handleNavigateBack);

    return () => {
      eventBus.off('navigateBack', handleNavigateBack);
    };
  }, [navigate]);

  return null;
};

export default NavigationEventListener;
